import { formatDateTime } from "../../../helpers/Util";
import { OtsAircraft } from "../../../Models/OtsAircraft";

export function getAirborneLabelMessage(otsEvent: OtsAircraft): { label: string; isDiversion: boolean } {
    const diversionResult = getDiversionLabel(otsEvent);
    const labels = [
        getETALabel(otsEvent),
        diversionResult.label,
        getTaxxingLabel(otsEvent),
        getLandedLabel(otsEvent),
    ];

    return {label: labels.filter(label => label).join(" ") , isDiversion: diversionResult.isDiversion};
}

export function getETALabel(otsEvent: OtsAircraft): string {
    if (
        otsEvent?.EstimatedArrivalTime &&
        !otsEvent?.InboundFlight?.Flight?.ActualInTimeUTC &&
        !otsEvent?.InboundFlight?.Flight?.ActualOnTimeUTC &&
        !otsEvent?.DivertingToStation
      ) {
        let {time} = formatDateTime(otsEvent?.EstimatedArrivalTime);
        return `ETA ${time}`;
        }
    return "";
}

export function getDiversionLabel(otsEvent: OtsAircraft): {label: string, isDiversion: boolean} {
    if (
        otsEvent?.DivertingToStation &&
        otsEvent?.InboundFlight?.Flight?.ActualOnTimeUTC === null
      ) {
        let etaValue = "";
        if(otsEvent?.EstimatedArrivalTime){
            let {time} = formatDateTime(otsEvent?.EstimatedArrivalTime);
            etaValue = ` - ${time}`;
        }
        return {label: `Diverting to ${otsEvent.DivertingToStation}${etaValue}`, isDiversion: true};
      }
    return {label: "", isDiversion: false};
}

export function getTaxxingLabel(otsEvent: OtsAircraft): string {
    if (
        otsEvent?.InboundFlight?.Flight?.ActualOnTimeUTC &&
        !otsEvent?.InboundFlight?.Flight?.ActualInTimeUTC
      ) {
        let {time} = formatDateTime(otsEvent?.OnTimeStationLocal);
        return `Taxiing - ${time}`;
      }
    return "";
}

export function getLandedLabel(otsEvent: OtsAircraft): string {
    if (
        otsEvent?.InboundFlight?.Flight?.ActualInTimeUTC 
      ) {
        let {time} = formatDateTime(otsEvent?.InboundFlight?.Flight?.ActualInTimeUTC);
        return `Landed at ${time}`;
      }
      return "";
}